import type { Promisable } from "type-fest";

import { PatientCreateEdit } from "../PatientIndex/PatientCreateEdit.js";
import type { ValidationSchema } from "./CollectCriteriaDemographics.js";

export type CreatePatientProps = {
  initialValues?: ValidationSchema;
  onCancel: () => void;
  onCreated?: (patientId: string) => Promisable<void>;
};

export const CreatePatient = ({
  initialValues,
  onCancel,
  onCreated,
}: CreatePatientProps) => {
  return (
    <PatientCreateEdit
      mode={"create"}
      exitPatientCreate={onCancel}
      onCreated={onCreated}
      initialState={
        initialValues === undefined
          ? null
          : {
              givenName: initialValues.givenName ?? "",
              familyNameAndAddress: {
                name: initialValues.familyName ?? "",
                address: "",
                isConfirmed: false,
              },
              isPatientDateOfBirth: initialValues.dateOfBirthIsExact === true,
              dateOfBirth: initialValues.dateOfBirthExact,
              deathNotificationStatus: null,
            }
      }
    />
  );
};
